import { $t, i18n } from "~/i18n.js";
import React from "react";
import { Card, Tabs } from "antd";
import { Topmeteo } from "~/components/topmeteo/topmeteo.jsx";

export const MeteoCard = ({ club, meteo, topmeteo }) => {
  if (!topmeteo && club.country !== "NL") return null;

  return (
    <Card size="small" className="topCard" title={$t("Meteo")}>
      
      {club.country !== "NL" && <Topmeteo topmeteoData={topmeteo}  unit={i18n.height_unit} />}

      {club.country === "NL" && <Tabs items={[
        topmeteo && Object.keys(topmeteo).length > 0 && {
          key: "topmeteo",
          label: $t("Topmeteo"),
          children: <Topmeteo topmeteoData={topmeteo} unit={i18n.height_unit} />,
        },
        ...meteo.map((m, key) => ({
          key: String(key),
          label: m.timestamp,
          children: (
            <>
              <p
                className="small meteo"
                dangerouslySetInnerHTML={{ __html: m.message }}
              />
              <p className="small gray" style={{ marginTop: 6 }}>
                Bron:{" "}
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://knmi.nl/nederland-nu/luchtvaart/weerbulletin-kleine-luchtvaart"
                >
                  KNMI
                </a>
              </p>
            </>
          ),
        })),
      ].filter(Boolean)} />
}
    </Card>
  );
};
